import React, { useEffect, useRef } from "react";

import { useLocation } from "react-router-dom";

import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";
import { analyticsTracker } from "@utils/analytics";
import { observer } from "mobx-react";

import {
	BetBuilderPicksPopupBody,
	BetBuilderPicksPopupFooter,
	BetBuilderPicksPopupHeader,
} from "./components/BetBuilderPopup";

export default observer(function BetBuilderPicksPopup() {
	const popupElement = useRef<null | HTMLDivElement>(null);
	const location = useLocation();

	const rootStore = useRootAppStore();

	useFixBody(
		true,
		rootStore.quickPlayStore.betBuilderPicksStore.isPopupDisplayed
	);

	if (
		!location.pathname.includes("home") &&
		!location.pathname.includes("bet-builder-picks")
	) {
		rootStore.quickPlayStore.betBuilderPicksStore.deactivatePopup();
	}

	useEffect(() => {
		analyticsTracker.trackModalInteraction("bb-picks");
	}, []);

	useEffect(() => {
		popupElement.current?.scrollTo({ top: 0 });
	}, [rootStore.quickPlayStore.betBuilderPicksStore.selectedBetSlip]);

	if (!rootStore.quickPlayStore.betBuilderPicksStore.selectedBetSlip) {
		return null;
	}

	return (
		<div className="popup popup--full">
			<div className="popup__card popup--most__card popup--bbp__card">
				<BetBuilderPicksPopupHeader
					slipNumber={
						rootStore.quickPlayStore.betBuilderPicksStore.slipIndex
					}
					isLive={
						rootStore.quickPlayStore.betBuilderPicksStore
							.selectedBetSlip.isLive
					}
					BBPick={
						rootStore.quickPlayStore.betBuilderPicksStore
							.selectedBetSlip
					}
					cb={
						rootStore.quickPlayStore.betBuilderPicksStore
							.deactivatePopup
					}
				/>
				<div
					className="popup__body popup--qp__body popup--bbp__body"
					ref={popupElement}
				>
					<BetBuilderPicksPopupBody
						key={
							rootStore.quickPlayStore.betBuilderPicksStore
								.selectedBetSlip.id
						}
						BBPick={
							rootStore.quickPlayStore.betBuilderPicksStore
								.selectedBetSlip
						}
					/>
				</div>
				<BetBuilderPicksPopupFooter
					slip={
						rootStore.quickPlayStore.betBuilderPicksStore
							.selectedBetSlip
					}
					store={rootStore.quickPlayStore.betBuilderPicksStore}
				/>
			</div>
		</div>
	);
});
